<template>
  <div class="out">
    <div class="page-title">
      <div class="container">
        <b-jumbotron
          :header="header"
          :lead="leader"
          style="background-color: rgba(0, 0, 0, 0)"
        />
      </div>
    </div>
    <div class="stickybar">
      <a :style="partI===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(1)">业务挑战</a>
      <a :style="partII===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(2)">解决方案</a>
      <a :style="partIII===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(3)">解决方案优势</a>
      <a :style="partIV===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(4)">成功故事</a>
      <!-- <a :style="partV===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(5)">相关产品</a> -->
    </div>
    <div
      ref="parti"
      class="review"
      style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <div id="partone" class="top-text contenttext">
          <h3>业务挑战</h3>
        </div>
        <introduceCard :arr="cardarr" style="padding-bottom:90px" />
      </div>
    </div>
    <div
      id="parttwo"
      ref="partii"
      class="review"
      style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0;background:url('https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202009/241459318i6k.png') no-repeat"
    >
      <div class="title">
        <p class="contenttext" style="color:white;text-align:center">
          <br >制造行业数字化转型解决方案
        </p>
        <div class="introducecard-frame">
          <div v-for="(item,index) in arr2" :key="index" :class="{hoverChange:nowindex2 === index}" class="introducecard2" @mouseenter="mouseOver2(index)" @mouseleave="mouseLeave2(index)">
            <div :style="nowindex2===index ? 'overflow:visible;color:white':'overflow:hidden;color:white'" class="introduceText animation">
              <div class="card-title2"><h4>{{ item.title }}</h4></div>
              <div class="card-text2">{{ item.content }}</div>
              <div v-if="nowindex2===index" class="introduceButton2">
                <router-link class="experience-link" to="/aboutUs">详情咨询</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="partthree"
      ref="partiii"
      class="review"
      style="background-color: rgba(128, 126, 126, 0.074); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <p class="contenttext">
          <br >解决方案优势
        </p>
        <introduceCard3 :arr="cardarr2" style="padding-bottom:90px" />
        <!-- <div class="introducecard-frame">
          <div v-for="(item,index) in arr3" :key="index" class="introducecard2" style="height:364px">
            <div class="image3">
              <img src="https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/1118203743vj.png" alt="">
            </div>
            <div :class="{hoverChange2:nowindex3 === index}" class="introduceText3" @mouseenter="mouseOver3(index)" @mouseleave="mouseLeave3(index)">
              <div class="card-title3"><h4>{{ item.title }}</h4></div>
              <div class="card-text3">{{ item.content }}</div>
              <a v-if= "nowindex3 === index">
                <div class="mybtn" >案例详情</div>
              </a>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div
      id="partfour"
      ref="partiv"
      class="review"
      style="background: rgba(234,239,243,1); margin-left: 0; margin-right: 0;padding-bottom: 60px;"
    >
      <div class="title">
        <card :arr3="arr3" />
      </div>
    </div>
    <!-- <div
      id="partfive"
      ref="partv"
      class="review"
      style="background-color: rgba(128, 126, 126, 0.074); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <p class="contenttext">
          <br >相关产品
        </p>
        <div class="introducecard-frame">
          <div v-for="(item,index) in arr" :key="index" :class="{hoverChange:nowindex === index}" class="introducecard" @mouseenter="mouseOver(index)" @mouseleave="mouseLeave(index)">
            <div v-if="nowindex !== index" class="introduceImage">
              <img :src="item.link" alt="">
            </div>
            <div class="introduceText">
              <div class="card-title"><h4>{{ item.title }}</h4></div>
              <div class="card-text">{{ item.content }}</div>
              <div :style="nowindex===index ? {'opacity':1,'marginTop':'40%'} :'opacity:0'" class="introduceButton">
                <a class="experience-link" href="/access">免费体验</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import introduceCard3 from '@/components/introducecard3'
import introduceCard from '@/components/introducecard2'
import Card from '@/components/introducecard'
export default {
  name: 'HelloWorld',
  components: { introduceCard, Card, introduceCard3 },
  data() {
    return {
      header: '电子行业解决方案',
      leader: '提供研产供销一体化解决方案，聚焦产品全价值链进行管控，提升企业运营效率和核心竞争力',
      cardarr: [
        { title: '经营决策缺乏全面的信息支持', content: '企业信息化应用水平不高。各管理系统之间不能信息共享，形成“信息孤岛”，企业决策层和管理层无法提供信息化系统掌握企业经营活动的真实情况和经营全貌', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14235107jh7x.png' },
        { title: '制造系统难以保障对客户的准时交付能力', content: '电子企业面向库存备料和面向订单两种生产模式并存，企业缺乏有效的计划体系和工具，手工编制计划难度大，订单数量多，变更频繁，跟踪困难，容易造成交货进度延迟', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14235221aulm.png' },
        { title: '供应链管理难以及时准确保障物料', content: '电子产品使用原材料种类繁多，重要元器件国外采购周期过长，客户订单交货期短，合理物料采购计划编制比较困难', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/142353046kuz.png' },
        { title: '产品管理难以适应产品发展和需求变化', content: '产品更新换代频繁，客户订单变更频繁，产品设计变更管理困难，版本控制复杂', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14235535dknn.png' }
      ],
      cardarr2: [
        { title: '触屏报工、电子看板，实现生产、库房现场', content: '提供屏+制造的解决方案，形成及时报工体系。达到“数据透明、智慧生产”的目标', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14235107jh7x.png' },
        { title: '建立计划和物控体系，及时应对变化', content: '建立适合电子行业的生产计划体系和物控体系，形成以计划驱动的高效协同体系，快速响应市场变化', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14235221aulm.png' },
        { title: '供应链协同，精准把控供应链', content: '连接供应商、客户，采集供应链各环节信息，实现对供应链的全局掌控及根据各个节点数据及时反馈调优，精准把控供应链', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/142353046kuz.png' },
        { title: 'PLM+ERP+MES研产供销一体化，敏捷响应外部变化', content: '通过PLM+ERP+MES一体化平台，打通企业数据壁垒，实现销售、研发、采购、生产、等全业务链高效协同，敏捷响应外部变化', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14235535dknn.png' }
      ],
      arr: [
        { title: '第一个', content: '为业主/租户开启一站式服务新体验，全面提升服务水平，重塑企业核心竞争力', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/161909211684.png' },
        { title: '第二个', content: '为业主/租户开启一站式服务新体验，全面提升服务水平，重塑企业核心竞争力', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/16190843torb.png' },
        { title: '第三个', content: '为业主/租户开启一站式服务新体验，全面提升服务水平，重塑企业核心竞争力', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/16191004yn4i.png' },
        { title: '第四个', content: '为业主/租户开启一站式服务新体验，全面提升服务水平，重塑企业核心竞争力', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/16191052buyw.png' }
      ],
      arr2: [
        { title: '财务与成本管理解决方案', content: '构建高效的业财一体化财务核算能力，能够满足多组织、国际化、多会计政策的财务核算能力，借助于移动应用和金税、银行的连接，能够高效的提供财务服务能力' },
        { title: '质量与追溯管理解决方案', content: '质量管理模块通过从原材料的检验、生产到成品出库的全流程质量精细化管控，以及过程数据的完整追溯，为零部件质量控制、质量改进及售后维修、召回高效的追溯查询提供支撑' },
        { title: '生产与运营管理解决方案', content: '围绕 围绕精细化计划管控、透明化化生产执行、全面质量管理等作为落地支撑，助力电子行业企业从订单接收、计划、生产执行到售后及追溯的全流程管控' },
        { title: '供应链管理解决方案', content: '以条码作为载体，提供可视化的全局库存管理，提高数据准确性、实时性。提高操作员的工作效率，实现过程中的防呆、防错，并实现全产业链的质量追溯' },
        { title: '研发管理解决方案', content: '在现代研发管理思想体系框架下充分结合电子行业质量管理体系所提供的管理支持，支撑电子产品全生命周期研发管理，并在研发过程中和业务部门进行高效协同，提高效率，在源头开始控制成本' }
      ],
      arr3: [
        { title: '广州亿航：数字化转型助力智能高速成长', content: '建立了透明化、精细化的管理体系，保证了亿航在产品快速迭代和管理快速迭代的模式下，效率和效益的提升', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/12093456ygve.png' },
        { title: '珠海迈科智能：破局创新迷雾，运营效率制胜', content: '计划是运营效率的核心关键，MRP、缺料分析、齐套分析等三个层级的物料计划，帮助珠海迈科智能保障材料的及时供应及客户订单的准时交付', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/12093415f3i6.png' },
        { title: '凌创电子：数字化协同研发助力“新”制造', content: '规范企业内部各部门之间协作流程，实现内部管理全面协同提升。建立起一套统一、高效的产品研发全生命周期管理', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/12093310f55v.png' },
        { title: '步科：低成本智能制造 助力持续精益改善', content: '产供销高效协同，库存得到合理控制，保障生产日清日结，生产数字化，实现过程精细化管控，生产精益化，产能翻番，节省仓储空间，配送时间降低', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/120931533nt2.png' }
      ],
      arr4: [
        { content: '生活服务' },
        { content: '车厂管理' },
        { content: '运营中心' },
        { content: '移动验房' },
        { content: '智能门禁' },
        { content: '云客服' },
        { content: '云收费' },
        { content: '云租赁' }
      ],
      arr5: [
        { title: '智慧园区', content: '我家云赋能园区物业企业，建立以园区管理、运营平台为基础，产业服务平台为核心、大数据运营平台为支撑的智慧园区综合服务平台，实现园区员工在线、客户在线、服务在线、管理在线' },
        { title: '资产运营', content: '聚焦资产盘点与运营，我家云为企业提供标准化的业务管理方案，助力企业资产运营全流程闭环管理，在空间运营的基础上，不断延伸内容服务，利用数字化创造更多商业机会，让资产释放价值方案' },
        { title: '智慧物业', content: '围绕 IoT服务、业务服务、增值服务三个领域，赋能物业企业构建数字化能力，IoT服务提供在智能化管理和服务应用场景上的基础平台支撑；增值服务在教育、健康、理财、购物等生活服务方面提供面向C端的服务，面向企业内部提供人、财、物的管理和业务能力' },
        { title: '智慧园区', content: '我家云赋能园区物业企业，建立以园区管理、运营平台为基础，产业服务平台为核心、大数据运营平台为支撑的智慧园区综合服务平台，实现园区员工在线、客户在线、服务在线、管理在线' },
        { title: '资产运营', content: '聚焦资产盘点与运营，我家云为企业提供标准化的业务管理方案，助力企业资产运营全流程闭环管理，在空间运营的基础上，不断延伸内容服务，利用数字化创造更多商业机会，让资产释放价值方案' },
        { title: '智慧物业', content: '围绕 IoT服务、业务服务、增值服务三个领域，赋能物业企业构建数字化能力，IoT服务提供在智能化管理和服务应用场景上的基础平台支撑；增值服务在教育、健康、理财、购物等生活服务方面提供面向C端的服务，面向企业内部提供人、财、物的管理和业务能力' },
        { title: '天安云谷：打造产业园区新生态', content: '携手金蝶我家云构建“园区+互联网”云平台，在企业运营、商业运营、战略决策、全面管控等方面实现线上化、移动化、数据化、智能化。' },
        { title: '深业集团：智慧资产数字化运营管理', content: '深业集团携手金蝶我家云构建“资产管理+用户服务”数字化运营平台，对内进行统一集团管控、策略管控、监管管理、流程管理，提升运营效率，释放管理价值。' }
      ],
      nowindex: '',
      nowindex2: '',
      nowindex3: '',
      nowindex4: 0,
      nowIndex: [0],
      partI: false,
      partII: false,
      partIII: false,
      partIV: false
      // partV: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollLisenter)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollLisenter)
  },
  methods: {
    jump: function(x) {
      if (x === 1) {
        x = '#partone'
      }
      if (x === 2) {
        x = '#parttwo'
      }
      if (x === 3) {
        x = '#partthree'
      }
      if (x === 4) {
        x = '#partfour'
      }
      if (x === 5) {
        x = '#partfive'
      }
      document.querySelector(x).scrollIntoView(true)
    },
    scrollLisenter: function() {
      var length = document.documentElement.scrollTop + 37
      if (length >= 0 && length < this.$refs.partii.offsetTop) {
        this.partI = true
      } else this.partI = false
      if (length > this.$refs.partii.offsetTop && length < this.$refs.partiii.offsetTop) {
        this.partII = true
      } else this.partII = false
      if (length > this.$refs.partiii.offsetTop && length < this.$refs.partiv.offsetTop) {
        this.partIII = true
      } else this.partIII = false
      // if (length > this.$refs.partiv.offsetTop && length < this.$refs.partv.offsetTop) {
      //   this.partIV = true
      // } else this.partIV = false
      if (length > this.$refs.partiv.offsetTop) {
        this.partIV = true
      } else this.partIV = false
    },
    mouseOver: function(x) {
      this.nowindex = x
    },
    mouseLeave: function(x) {
      this.nowindex = -1
    },
    mouseOver2: function(x) {
      this.nowindex2 = x
    },
    mouseLeave2: function(x) {
      this.nowindex2 = -1
    },
    mouseOver3: function(x) {
      this.nowindex3 = x
    },
    mouseLeave3: function(x) {
      this.nowindex3 = -1
    },
    mouseOver4: function(x) {
      this.nowindex4 = x
    },
    mouseLeave4: function(x) {
      this.nowindex4 = x
    },

    mouseOvers: function(type, index) {
      this.nowIndex[type] = index
    },
    mouseLeaves: function(type, index) {
      this.nowIndex[type] = 0
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

.out{
  display: inline-block;
  vertical-align:top;
  width:100%;
}

.page-title {
  background: url('https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/20170101okgl.jpg');
  background-size: 100% 400px;
  height: 100%;
  text-align: left;
  padding-top: 60px;
  padding-bottom: 2px;
  /* max-width: 1200px; */
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.title {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
}

.titletext {
  font-size: 50px;
  font-family: "Permanent Marker", cursive;
  color: rgb(22, 21, 21);
}

.contenttext {
  color: rgb(0, 0, 0);
  font-size: 32px;
  /* font-family: Georgia, "Times New Roman", Times, serif; */
  text-align: center;
  padding: 6%;
  padding-top: 4%;
  margin:0;
}

.top-text {
  padding: 50px 0 50px 0;
}

.card {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.introducecard-frame{
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 50px;
}

.introducecard {
  background-color: rgba(236, 234, 227, 0.39);
  width:293px;
  height:315px;
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 3px;
  position: relative;
}

.introducecard2 {
  /* background-color: rgba(243, 241, 235, 0.473); */
  /* background-color:rgba(247,247,247,1); */
  background: rgba(35,133,237,0.2);
  height:264px;
  width:584px;
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
  margin:0px 8px 20px 8px;
}

.introduceImage {
  padding-top: 50px;
}

.introduceText {
  padding: 20px 30px 30px 30px;
}

.introduceButton {
  border:1px solid rgba(255,255,255,1);
  background-color: rgba(59, 124, 209, 0.39);
  opacity: 0;
  width:100px;
  margin: auto;
  ;
}

.introduceButton2 {
  border:1px solid rgba(255,255,255,1);
  bottom: 75px;
  background-color: rgba(0, 203, 253, 1);
  width:100px;
  margin: auto;
}

.introduceButton a {
    color:rgba(251,252,253,1);
    font-size:14px;
    text-align: center;
    line-height: 40px;
    text-decoration: none;
}

.introduceButton2 a {
    color:rgba(251,252,253,1);
    font-size:14px;
    text-align: center;
    line-height: 40px;
    text-decoration: none;
}

.hoverChange {
  background-color: rgba(20, 130, 238, 1);
  transition: 0.4s;
  color:white;
  box-shadow: 0px 0px 5px #000;
}

.animation {
  position: relative;
  transition: all 0.4s;
}

.animation:hover {
  transition: transform 0.4s;
  transform: translateY(-40px);
}

.card-title2 {
  margin-top: 10%;
  text-align: left;
}

.card-title3 {
  margin-top: 1%;
  text-align: left;
}

.card-text2 {
  word-break:hyphenate;
  font-size: 14px;
  padding-top: 2%;
  padding-bottom: 2%;
  text-align: left;
  height:120px;
}

.card-text3 {
  font-size: 14px;
  text-align: left;
}

.introduceText3 {
  background-color: rgb(255, 255, 255);
  position: absolute;
  bottom:0;
  transition: all 0.4s;
  height: 140px;
  padding:4%;
}

.introduceText3:hover {
  height: 200px;
  transition:0.4s;
}

.introducecard2 img {
  width:100%;
}

.mybtn {
  width:25%;
  background-color: rgb(62, 88, 112);
  margin: 30px auto;
  padding: 1%;
  color: white;
}

.leftMenu {
  display: flex;
  flex-direction: column;
  width: 150px;
  text-align: left;
  padding: 10% 0%;
  box-shadow: -20px 0px 20px -10px rgb(0 0 0 / 4%) inset;
}

.leftMenu-item {
  padding:18% 10% 18% 10%;
  position: relative;
}

.rightContent {
  width: 100%;
  background-color: rgba(128, 126, 126, 0.075);
  padding:10%;
}

.hoverItem {
  background-color: rgba(45,139,238,1);
  color: ivory;
  width:140%;
  font-size: 20px;
}

.big-title {
  margin: auto;
  padding:5%;
}

.stickybar {
  position: sticky;
  top: 0;
  display: flex;
  background-color: white;
  z-index: 99;
  padding: 0% 7% 0% 13%;
}

.stickybar a{
  padding: 2% 4%;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/views/solutions/components/manufacture.vue